'use strict';
import moment from 'moment';
import {createEventHandler, mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {DateTimePickerView} from './DateTimePickerView';


export const StreamedComponent = (props$) => {
  const {
    handler: onChange, // what onSet
    stream: change$,
  } = createEventHandler();

  const {
    handler: onUpdate, // was onChange
    stream: update$,
  } = createEventHandler();

  const moment$ = props$
    .map(props => props.value)
    .distinctUntilChanged()
    .map(value => value ? moment(value) : moment())
    .switchMap(m =>
      update$
        .startWith(m)
    )
    .scan((acc, m) => m);

  change$
    .withLatestFrom(moment$, props$)
    .takeUntil(props$.last())
    .subscribe(([_, m, props]) => {
      props.onChange({
        value: m.valueOf(),
      });
    });

  return props$
    .combineLatest(
      moment$,
      (props, moment) => ({
        ...props,
        moment,
        onChange,
        onUpdate,
      }));
};

export const DateTimePickerComponent = mapPropsStream(StreamedComponent)(DateTimePickerView);



// WEBPACK FOOTER //
// ./src/js/components/temporal/DateTimePicker/DateTimePickerComponent.js